{
  "score": {
    "trustScore": 0,
    "stars": 0
  },
  "numberOfReviews": 0,
  "profileUrl": "",
  "reviews": [],
  "lastUpdatedAt": ""
}
